import { render } from "./Home.vue?vue&type=template&id=bc743c22"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bc743c22&lang=scss"

import exportComponent from "/Applications/projects/bas-taj-korak-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__